import React from "react";
import { Typography } from "antd";

const { Paragraph } = Typography;

const MessageScanError = () => {
  return (
    <div className='text-start'>
      <Paragraph>
        The network tests were not able to complete, and there is not enough data to accurately analyze this computer.
      </Paragraph>
      <Paragraph>You can retry the network tests (recommended) or cancel the detection.</Paragraph>
    </div>
  );
};

export default MessageScanError;
